import { render, staticRenderFns } from "./ConfigurationLayout.vue?vue&type=template&id=31e3ef36"
import script from "./ConfigurationLayout.vue?vue&type=script&lang=js"
export * from "./ConfigurationLayout.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationLayout.vue?vue&type=style&index=0&id=31e3ef36&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports